<template>
  <!-- Dialog -->
  <v-dialog v-model="viewModel.dialog.value" persistent max-width="1200px">
    <v-card>
      <!-- Title Section -->
      <v-card-title class="d-flex justify-between align-center">
        <span class="text-subtitle-1 font-weight-bold"> Estado de Cuenta </span>
        <v-spacer></v-spacer>
        <v-btn
          :disabled="viewModel.loadingPdf.value"
          variant="flat"
          icon
          @click="viewModel.closeDialog()"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-divider></v-divider>

      <!-- Estado de Cuenta Table -->
      <v-card-text>
        <v-container fluid class="pa-0">
          <v-row dense>
            <v-col cols="12">
              <v-card flat>
                <v-row>
                  <v-col cols="12">
                    <v-table
                      density="compact"
                      height="400px"
                      fixed-header
                      style="
                        border-left: 7px solid rgb(var(--v-theme-primary), 0.4);
                      "
                    >
                      <thead>
                        <tr>
                          <th class="text-left">Concepto</th>
                          <th class="text-left">Fecha</th>
                          <th class="text-left">Hora</th>
                          <th class="text-left" style="min-width: 100px">
                            Total
                          </th>
                          <th class="text-left" style="min-width: 100px">
                            Saldo
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(item, idx) in viewModel.accountStatement
                            .value"
                          :key="`estado-${idx}`"
                        >
                          <td class="text-caption">{{ item.concepto }}</td>
                          <td class="text-caption">
                            {{ viewModel.formatDate(item.fecha) }}
                          </td>
                          <td class="text-caption">{{ item.hora }}</td>
                          <td class="text-caption">
                            {{ viewModel.coin.value }}
                            {{ viewModel.getFloat(item.total) }}
                          </td>
                          <td class="text-caption">
                            {{ viewModel.coin.value }}
                            {{ viewModel.getFloat(item.saldo) }}
                          </td>
                        </tr>
                      </tbody>
                    </v-table>
                  </v-col>
                  <v-col class="text-end">
                    <v-btn
                      flat
                      color="primary"
                      class="text-none"
                      :loading="viewModel.loadingPdf.value"
                      @click.prevent="viewModel.downloadAccountStatement"
                    >
                      <v-icon class="mr-2">mdi-download</v-icon>
                      Descargar Estado de Cuenta
                    </v-btn>
                  </v-col>
                </v-row>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script setup lang="ts">
import { defineExpose } from "vue";
import StateOfAccountDialogViewModel from "@/viewmodels/dialogs/StateOfAccountDialogViewModel";
import { Saving } from "@/models/Saving";
import { Movimiento } from "@/models/Movimiento";

const viewModel = new StateOfAccountDialogViewModel();

// Exponemos directamente los métodos sin usar `bind`
defineExpose({
  openDialog: (saving: Saving, movements: Movimiento[]) =>
    viewModel.openDialog(saving, movements),
  closeDialog: () => viewModel.closeDialog(),
});
</script>
